import React from 'react'

const ConvertImage = ({ imageString = '', width = '100%', type = 'jpg' }) => {
    return <img src={'data:image/' + type + ';base64,' + imageString} width={width} alt="" />
  }

export default ConvertImage